module.exports = __webpack_public_path__ + "img/505.84a88784.png";